<template>
  <el-col :lg="span" :md="span" :sm="24" :xl="span" :xs="24">
    <div class="left-panel">
      <slot />
    </div>
  </el-col>
</template>

<script>
  export default {
    name: 'VabBoxAreaLeftPanel',
    props: {
      span: {
        type: Number,
        default: 14,
      },
    },
  }
</script>
